module.exports = __webpack_public_path__ + "img/findmyweatherlogowhite.b3fa3171.png";